/** Normalize pathname for client routing (trailing slashes → root form). */
export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}

export function isNamePath(pathname: string): boolean {
  return normalizePath(pathname) === '/name'
}
